import { classNames } from '@panwds/tailwindcss';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '../Button/Button.esm.js';
import '@panwds/icons';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';

const ToggleButton = ({ size = 'md', appearance = 'secondary', dataMetrics, dataTestId, disabled = false, buttons, selectedButtonId = 0, setSelectedButtonId }) => {
    const intl = useIntl();
    const handleButtonClick = (id) => {
        setSelectedButtonId(id);
    };
    const secondary = 'tw-text-blue-800 tw-bg-blue-200 tw-border-blue-800 dark:tw-text-blue-200 dark:tw-bg-blue-600 dark:tw-border-blue-400';
    const tertiary = 'tw-text-gray-900 tw-bg-gray-300 tw-border-gray-900 dark:tw-text-blue-steel-200 dark:tw-bg-blue-steel-700 dark:tw-border-blue-steel-500';
    const leftButtonNotSelected = classNames('tw-rounded-r-none tw-border-r hover:tw-z-10 focus:tw-z-10 active:tw-z-10');
    const rightButtonNotSelected = 'tw-rounded-l-none';
    const leftButtonSelected = classNames(appearance === 'secondary' ? secondary : tertiary, 'tw-rounded-r-none tw-border-r tw-z-10 hover:tw-z-10 focus:tw-z-10 active:tw-z-10');
    const rightButtonSelected = classNames(appearance === 'secondary' ? secondary : tertiary, 'tw-rounded-l-none tw-border-l');
    useEffect(() => {
        if (disabled)
            setSelectedButtonId(-1);
    }, [disabled]);
    return (React.createElement("div", { "data-metrics": dataMetrics || 'toggle-button-metrics', "data-testid": dataTestId || 'toggle-button', className: "tw-flex" },
        React.createElement("span", { "data-testid": "left-toggle-button", onClick: () => handleButtonClick(0) },
            React.createElement(Button, { "aria-label": intl.formatMessage({
                    defaultMessage: 'Left Toggle Button',
                    id: 'UaxQLv',
                    description: 'This button displays the left toggle button'
                }), appearance: appearance, disabled: disabled, icon: buttons.left.icon ? buttons.left.icon : undefined, size: size, addClassName: classNames(0 === selectedButtonId ? leftButtonSelected : leftButtonNotSelected) }, buttons.left.value || '')),
        React.createElement("span", { "data-testid": "right-toggle-button", onClick: () => handleButtonClick(1) },
            React.createElement(Button, { "aria-label": intl.formatMessage({
                    defaultMessage: 'Right Toggle Button',
                    id: 'ovjpYX',
                    description: 'This button displays the right toggle button'
                }), appearance: appearance, disabled: disabled, icon: buttons.right.icon, size: size, addClassName: classNames('tw--ml-px', 1 === selectedButtonId ? rightButtonSelected : rightButtonNotSelected) }, buttons.right.value || ''))));
};

export { ToggleButton };
//# sourceMappingURL=ToggleButton.esm.js.map
